import { render, staticRenderFns } from "./UpdatePermissionProfiles.vue?vue&type=template&id=953514fa&"
import script from "./UpdatePermissionProfiles.vue?vue&type=script&lang=js&"
export * from "./UpdatePermissionProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports